import React, {useState, useEffect, useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { parseDateTime } from '../../../common/date-time';

import { useSelector, useDispatch } from 'react-redux';
import { getCircuitVpnDetailsByEventsInit} from './redux/actions';
import './DetailsEventsDialog.scss';


const DetailsEventsDialog = ({dialogData, setDialogData}) => {

  const circuitVpnDetails = useSelector((state) => state.circuitVpn.circuitVpnDetailsbyEvents);
  const [tableFilters, setTableFilters] = useState(null);
  const detailsSummaryTableRef = useRef(null);
  const dispatch = useDispatch();

    useEffect(() => {
        initializeTableFilter();
    }, []);

    useEffect(() => {
        if (!!dialogData) {
            fetchDetails();
        }
    },[dialogData]);

    const fetchDetails = () => dispatch(getCircuitVpnDetailsByEventsInit(dialogData));

    /**
    * Function to initialize Table filter
    */
  const initializeTableFilter = () => {
    setTableFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      event: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      message: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
    });
  };

    const timestampTemplate = ({timestamp}) => (
      !!timestamp ? parseDateTime(timestamp) : <span>-</span>
    )

    return (
      <Dialog
          className="circuit-vpn-detail-dialog"
          visible={!!dialogData}
          onHide={() => setDialogData(null)}
          header={dialogData}
      >
          <DataTable
              value={circuitVpnDetails}
              ref={detailsSummaryTableRef}
              filters={tableFilters}
              filterDisplay="menu"
              sortField="timestamp"
              sortOrder={-1}
              emptyMessage="No logs found."
          >
              <Column header="Event" field="referenceId" sortable filter />
              <Column
                  header="Message"
                  field="logMessage"
                  sortable
                  filter
              />
              <Column
                  header="Timestamp"
                  field="timestamp"
                  body={timestampTemplate}
                  sortable
              />
          </DataTable>
      </Dialog>
  );
}

export default DetailsEventsDialog;